import api from "./api/api";
import TokenService from "./api/token";

class MeetingAdminService {
  status(id, status) {
    return api.post("/av/socket/status/", {
      'meeting_id': id,
      'status': status
    });
  }

  getAllMeetings() {
    return api.get("/av/meeting/list/admin/");
  }

  getAllUsers() {
    return api.get("/admin/users/list/");
  }

  searchUsers(query) {
    return api.get(`/admin/users/list/?search=${encodeURIComponent(query)}&filter=all&per_page=50`);
  }

  inviteUser(meeting_id, user_id) {
    return api.post("/av/attend/invite/", {
      'meeting_id': meeting_id,
      'user_id': user_id
    });
  }

  deleteUserInvite(id) {
    return api.delete("/av/attend/delete/" + id + "/");
  }

  createMeeting(name, start_date, start_time, building) {
    return api.post("/av/meeting/create/", {
      'name': name,
      'date': start_date,
      'time': start_time,
      'building': building
    });
  }

  deleteMeeting(id) {
    return api.delete("/av/meeting/delete/" + id + "/");
  }

  getMeeting(id) {
    return api.get("/av/meeting/admin/get/" + id + "/");
  }

  getMeetingWHIPUrl(id, room_id) {
    return api.get("/av/meeting/whip/" + id + "/" + room_id + "/");
  }

  updateMeeting(id, start_date, start_time) {
    return api.put("/av/meeting/update/", {
      'id': id,
      'date': start_date,
      'time': start_time
    });
  }

  clearRedis() {
    return api.get("/av/socket/redis/remove/");
  }

  refreshUser(id) {
    return api.post("/av/socket/refreshuser/",
      {
        user_id: id
      })
  }

  exportData(id, data) {
    return api.get("/export/" + data + "/" + id + "/", {
      responseType: 'blob'
    });
  }

  getMeetingStats(id) {
    return api.get("/av/socket/statistics/" + id + "/");
  }

  updateRSVP(meeting_id, user_id, rsvp) {
    return api.post("/av/attend/rsvpadmin/",
      {
        meeting_id: meeting_id,
        user_id: user_id,
        rsvp: rsvp
      }
    );
  }

  updateShares(meeting_id, attend_id, shares) {
    return api.post("/av/attend/sharesadmin/",
      {
        meeting_id: meeting_id,
        attend_id: attend_id,
        shares: shares
      }
    );
  }

  updateSyndesk(meeting_id, attend_id, syndesk) {
    return api.post("/av/attend/syndeskadmin/",
      {
        meeting_id: meeting_id,
        attend_id: attend_id,
        syndesk: syndesk
      }
    );
  }

  getInviteesStatistics(meeting_id, filter = 'investeerders') {
    return api.get("/av/attend/statistics/" + meeting_id + "/?filter=" + encodeURIComponent(filter));
  }
}

export default new MeetingAdminService();